import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { REDUCER_NAME, changeTabAllScore } from '../reducer';
import Const from '../Const';
import { I18n } from 'react-redux-i18n';
import { compose } from 'redux';
import SearchHighlight from '../common/SearchHighlight';
import { map } from 'lodash';

class FilterExchange extends PureComponent {
  clickFilter = item => {
    const { changeTabAllScore } = this.props;
    changeTabAllScore(item.key);
  };

  render() {
    const { currentTabAllScore } = this.props;
    return (
      <div className="list-filter">
        <SearchHighlight typeSearch={'highlight'} />
        {map(Const.listTabsAllScore, (item, index) => {
          let clssName =
            currentTabAllScore === item.key
              ? 'btn btn-cus-nomal btn-clicked mr-5'
              : 'btn btn-cus-nomal bg-b-color-3 mr-5';

          return (
            <div
              key={index}
              className={clssName}
              onClick={() => this.clickFilter(item)}
            >
              <span className="font-weight-bold">{I18n.t(item.name)}</span>
            </div>
          );
        })}
      </div>
    );
  }
}
const mapStateToProps = state => ({
  currentTabAllScore: state[REDUCER_NAME].currentTabAllScore,
  i18n: state.i18n,
});

const mapDispatchToProps = {
  changeTabAllScore,
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);
export default enhance(FilterExchange);
